import { createSelector } from 'reselect';

const tabSelector = ({ tab }) => tab;
const dataSelector = ({ data }) => data;
const nameSelector = ({ name }) => name;
const isDesktopSelector = ({ isDesktop }) => isDesktop;

export const chartDataSelector = createSelector(
  [tabSelector, dataSelector, isDesktopSelector],
  (tab, data, isDesktop) => {
    let barChartData = [];
    Object.keys(data).forEach((countryKey) => {
      barChartData.push({
        ...data[countryKey],
        countryKey,
      });
    });

    barChartData = barChartData.sort((a, b) => {
      if (a[tab] > b[tab]) {
        return 1;
      }
      if (a[tab] < b[tab]) {
        return -1;
      }
      return 0;
    });

    if (!isDesktop) {
      barChartData = barChartData.reverse();
    }

    return barChartData;
  },
);

export const countryRankSelector = createSelector(
  [chartDataSelector, nameSelector],
  (data, name) => data.map(country => country.name).indexOf(name) + 1,
);
